<template>
  <div class='TaxaFixa'>
    <input-reg
    :value="Frete.valor"
    @update:model-value="newValue => changeFrete({ valor: newValue })"
    text="Valor fixo (R$)"
    :cont="{ textAlign: 'left', width: '50%' }"
    :label="{ marginLeft: '3px', marginTop: '8px' }"
    :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
    Money
    />
    <input-reg
    :value="Frete.valormin"
    @update:model-value="newValue => changeFrete({ valormin: newValue })"
    text="Valor mínimo (R$)"
    :cont="{ textAlign: 'left', width: '50%' }"
    :label="{ marginLeft: '3px', marginTop: '8px' }"
    :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
    Money
    />
    <input-reg
    :value="Frete.gratisapartir"
    @update:model-value="newValue => changeFrete({ gratisapartir: newValue })"
    text="Grátis a partir de (R$)"
    :cont="{ textAlign: 'left', width: '50%' }"
    :label="{ marginLeft: '3px', marginTop: '8px' }"
    :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
    Money
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
export default {
  name: 'TaxaFixa',
  components: { InputReg },
  computed: {
    ...mapGetters(['Frete'])
  },
  methods: {
    ...mapActions(['changeFrete'])
  }
}
</script>

<style scoped>
.TaxaFixa {
  display: flex;
}
</style>
